import type { CSSProperties, ReactNode } from 'react'

import SavedStateIndicator from '@/components/reusables/SavedStateIndicator'

import { cn } from '@/utils'

type TimingScaffoldProps = {
  className?: string
  style?: CSSProperties
  sup?: ReactNode
  top?: ReactNode
  bottom?: ReactNode
  sub?: ReactNode
  below?: ReactNode
  loading?: boolean
  children?: ReactNode
}

export function TimingScaffold({
  className = '',
  style,
  sup,
  top,
  bottom,
  sub,
  below,
  loading,
  children,
}: TimingScaffoldProps) {
  return (
    <div
      className={cn(
        'relative w-28 pb-6 flex-none flex flex-col justify-stretch items text-center',
        className,
      )}
      style={style}
    >
      <div className="pt-8 w-full relative">
        <div className="absolute h-5 top-0 w-full">{sup}</div>
      </div>
      <div className="z-2 sticky top-35 flex-none min-h-max max-h-full h-6 w-full px-1">
        <div className="absolute h-4 -top-5 bottom-0 left-1/2 -translate-x-1/2 max-w-full">
          {top}
        </div>
        {children}
        {/* Inside the sticky block so it scrolls with the main value */}
        {below}
      </div>
      {/* z-index important for above element being clickable on scroll */}
      <div className="flex-1 z-1 w-full relative">
        <div className="absolute h-4 top-0 left-1/2 -translate-x-1/2 max-w-full">
          {bottom}
        </div>
        <div className="absolute h-5 -bottom-6 w-full">{sub}</div>
      </div>
      <SavedStateIndicator
        className="absolute z-30 bottom-1 right-1"
        saving={loading}
      />
    </div>
  )
}
